import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  primary,
  secondary,
  // grays,
  success,
  error,
  warning,
} from "./colorPalette";
const lightTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1920,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          height: "32px",
          fontFamily: "Roboto",
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            height: "32px",
          },
        },
      },
      defaultProps: {
        // disableElevation: true,
      },
    },
    MuiButtonBase: {
      defaultProps: {},
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          backgroundColor: "rgba(0, 0, 0, 0.02)",
        },
      },
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: primary["main"],
      light: primary[100],
      dark: primary[600],
    },
    secondary: {
      main: secondary["main"],
      light: secondary[100],
      dark: secondary[600],
    },
    success: {
      main: success["main"],
      light: success[100],
      dark: success[600],
    },
    info: {
      main: "#006FAA",
    },
    warning: {
      main: warning["main"],
      light: warning[100],
      dark: warning[600],
    },
    error: {
      main: error["main"],
      light: error[100],
      dark: error[600],
    },
  },
  shape: {
    borderRadius: 4,
  },
  shadows: [
    "none",
    "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)",
    "0px 1px 2px rgba(100, 116, 139, 0.12)",
    "0px 1px 4px rgba(100, 116, 139, 0.12)",
    "0px 1px 5px rgba(100, 116, 139, 0.12)",
    "0px 1px 6px rgba(100, 116, 139, 0.12)",
    "0px 2px 6px rgba(100, 116, 139, 0.12)",
    "0px 3px 6px rgba(100, 116, 139, 0.12)",
    "0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)",
    "0px 5px 12px rgba(100, 116, 139, 0.12)",
    "0px 5px 14px rgba(100, 116, 139, 0.12)",
    "0px 5px 15px rgba(100, 116, 139, 0.12)",
    "0px 6px 15px rgba(100, 116, 139, 0.12)",
    "0px 7px 15px rgba(100, 116, 139, 0.12)",
    "0px 8px 15px rgba(100, 116, 139, 0.12)",
    "0px 9px 15px rgba(100, 116, 139, 0.12)",
    "0px 10px 15px rgba(100, 116, 139, 0.12)",
    "0px 12px 22px -8px rgba(100, 116, 139, 0.25)",
    "0px 13px 22px -8px rgba(100, 116, 139, 0.25)",
    "0px 14px 24px -8px rgba(100, 116, 139, 0.25)",
    "0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
  ],
  overrides: {
    MuiAppBar: {
      colorInherit: {
        backgroundColor: "#333333",
        color: "#fff",
      },
    },
  },
  props: {
    MuiAppBar: {
      color: "inherit",
    },
  },
  typography: {
    h1: {
      fontFamily: "Roboto",
      fontSize: "3.8rem",
      fontWeight: 200,
    },
    h2: {
      fontFamily: "Roboto",
      fontSize: "2.5rem",
      fontWeight: 400,
    },
    h3: {
      fontFamily: "Roboto",
      fontSize: "1.875rem",
      fontWeight: 500,
    },
    h4: {
      fontFamily: "Roboto",
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    h5: {
      fontFamily: "Roboto",
      fontSize: "1.1rem",
      fontWeight: 600,
    },
    h6: {
      fontFamily: "Open Sans",
      fontSize: "1.1rem",
      fontWeight: 700,
    },
    fontFamily: "Open Sans",
    subtitle1: {
      fontWeight: 700,
      fontSize: "0.8rem",
      lineHeight: 1.55,
    },
    button: {
      fontWeight: 600,
      fontFamily: "Roboto Nato",
      lineHeight: 2,
      strokeWidth: 2,
      textTransform: "capitalize",
      borderRadius: 30,
    },
    overline: {
      lineHeight: 2.52,
      fontSize: "0.7rem",
      fontWeight: 600,
    },
    subtitle2: {
      fontWeight: 800,
    },
    fontSize: 14,
    body1: {
      fontSize: "0.9rem",
    },
    body2: {
      fontSize: "0.8rem",
    },
  },
});

const currentTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1920,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    // MuiToolbar: {
    //   styleOverrides: {
    //     root: {
    //       height: 50,
    //     },
    //   },
    // },
    // MuiAppBar: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: "#333333",
    //     },
    //   },
    // },
    MuiButtonBase: {
      defaultProps: {},
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          backgroundColor: "rgba(0, 0, 0, 0.02)",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#006faa",
    },
    secondary: {
      main: "#FFC20E",
    },
    success: {
      main: "#64A687",
    },
    info: {
      main: "#006FAA",
    },
    warning: {
      main: "#ff9800",
    },
    error: {
      main: "#c62828",
    },
  },
  shape: {
    borderRadius: 4,
  },
  shadows: [
    "none",
    "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)",
    "0px 1px 2px rgba(100, 116, 139, 0.12)",
    "0px 1px 4px rgba(100, 116, 139, 0.12)",
    "0px 1px 5px rgba(100, 116, 139, 0.12)",
    "0px 1px 6px rgba(100, 116, 139, 0.12)",
    "0px 2px 6px rgba(100, 116, 139, 0.12)",
    "0px 3px 6px rgba(100, 116, 139, 0.12)",
    "0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)",
    "0px 5px 12px rgba(100, 116, 139, 0.12)",
    "0px 5px 14px rgba(100, 116, 139, 0.12)",
    "0px 5px 15px rgba(100, 116, 139, 0.12)",
    "0px 6px 15px rgba(100, 116, 139, 0.12)",
    "0px 7px 15px rgba(100, 116, 139, 0.12)",
    "0px 8px 15px rgba(100, 116, 139, 0.12)",
    "0px 9px 15px rgba(100, 116, 139, 0.12)",
    "0px 10px 15px rgba(100, 116, 139, 0.12)",
    "0px 12px 22px -8px rgba(100, 116, 139, 0.25)",
    "0px 13px 22px -8px rgba(100, 116, 139, 0.25)",
    "0px 14px 24px -8px rgba(100, 116, 139, 0.25)",
    "0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
  ],
  overrides: {
    MuiAppBar: {
      colorInherit: {
        backgroundColor: "#333333",
        color: "#fff",
      },
    },
  },
  props: {
    MuiAppBar: {
      color: "inherit",
    },
  },
  typography: {
    h1: {
      fontFamily: "Roboto Slab",
      fontSize: "3.8rem",
      fontWeight: 200,
    },
    h2: {
      fontFamily: "Roboto Slab",
      fontSize: "2.5rem",
      fontWeight: 400,
    },
    h3: {
      fontFamily: "Roboto Slab",
      fontSize: "1.875rem",
      fontWeight: 500,
    },
    h4: {
      fontFamily: "Roboto Slab",
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    h5: {
      fontFamily: "Roboto Slab",
      fontSize: "1.1rem",
      fontWeight: 600,
    },
    h6: {
      fontFamily: "Open Sans",
      fontSize: "1.1rem",
      fontWeight: 700,
    },
    fontFamily: "Open Sans",
    subtitle1: {
      fontWeight: 700,
      fontSize: "0.8rem",
      lineHeight: 1.55,
    },
    button: {
      fontWeight: 600,
      fontFamily: "Roboto Slab",
      lineHeight: 2,
      strokeWidth: 2,
      textTransform: "capitalize",
      borderRadius: 30,
    },
    overline: {
      lineHeight: 2.52,
      fontSize: "0.7rem",
      fontWeight: 600,
    },
    subtitle2: {
      fontWeight: 800,
    },
    fontSize: 14,
    body1: {
      fontSize: "0.9rem",
    },
    body2: {
      fontSize: "0.8rem",
    },
  },
});
const darkTheme = createTheme({ palette: { mode: "dark" } });
const defaultTheme = createTheme({ palette: { mode: "light" } });

export {
  ThemeProvider,
  createTheme,
  defaultTheme,
  darkTheme,
  currentTheme,
  lightTheme,
};

// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import {
//   primary,
//   secondary,
//   // grays,
//   success,
//   error,
//   warning,
// } from "./colorPalette";
// const lightTheme = createTheme({
//   breakpoints: {
//     values: {
//       xs: 0,
//       sm: 600,
//       md: 1000,
//       lg: 1200,
//       xl: 1920,
//     },
//   },
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 4,
//           height: "32px",
//           fontFamily: "Roboto",
//         },
//       },
//       MuiInput: {
//         styleOverrides: {
//           root: {
//             height: "32px",
//           },
//         },
//       },
//       defaultProps: {
//         // disableElevation: true,
//       },
//     },
//     MuiButtonBase: {
//       defaultProps: {},
//     },
//     MuiOutlinedInput: {
//       styleOverrides: {
//         notchedOutline: {
//           backgroundColor: "rgba(0, 0, 0, 0.02)",
//         },
//       },
//     },
//   },
//   palette: {
//     mode: "light",
//     primary: {
//       main: primary["main"],
//       light: primary[100],
//       dark: primary[600],
//     },
//     secondary: {
//       main: secondary["main"],
//       light: secondary[100],
//       dark: secondary[600],
//     },
//     success: {
//       main: success["main"],
//       light: success[100],
//       dark: success[600],
//     },
//     info: {
//       main: "#006FAA",
//     },
//     warning: {
//       main: warning["main"],
//       light: warning[100],
//       dark: warning[600],
//     },
//     error: {
//       main: error["main"],
//       light: error[100],
//       dark: error[600],
//     },
//   },
//   shape: {
//     borderRadius: 0,
//   },
//   shadows: [
//     "none",
//     "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)",
//     "0px 1px 2px rgba(100, 116, 139, 0.12)",
//     "0px 1px 4px rgba(100, 116, 139, 0.12)",
//     "0px 1px 5px rgba(100, 116, 139, 0.12)",
//     "0px 1px 6px rgba(100, 116, 139, 0.12)",
//     "0px 2px 6px rgba(100, 116, 139, 0.12)",
//     "0px 3px 6px rgba(100, 116, 139, 0.12)",
//     "0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)",
//     "0px 5px 12px rgba(100, 116, 139, 0.12)",
//     "0px 5px 14px rgba(100, 116, 139, 0.12)",
//     "0px 5px 15px rgba(100, 116, 139, 0.12)",
//     "0px 6px 15px rgba(100, 116, 139, 0.12)",
//     "0px 7px 15px rgba(100, 116, 139, 0.12)",
//     "0px 8px 15px rgba(100, 116, 139, 0.12)",
//     "0px 9px 15px rgba(100, 116, 139, 0.12)",
//     "0px 10px 15px rgba(100, 116, 139, 0.12)",
//     "0px 12px 22px -8px rgba(100, 116, 139, 0.25)",
//     "0px 13px 22px -8px rgba(100, 116, 139, 0.25)",
//     "0px 14px 24px -8px rgba(100, 116, 139, 0.25)",
//     "0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)",
//     "0px 25px 50px rgba(100, 116, 139, 0.25)",
//     "0px 25px 50px rgba(100, 116, 139, 0.25)",
//     "0px 25px 50px rgba(100, 116, 139, 0.25)",
//     "0px 25px 50px rgba(100, 116, 139, 0.25)",
//   ],
//   overrides: {
//     MuiAppBar: {
//       colorInherit: {
//         backgroundColor: "#333333",
//         color: "#fff",
//       },
//     },
//   },
//   props: {
//     MuiAppBar: {
//       color: "inherit",
//     },
//   },
//   typography: {
//     h1: {
//       fontFamily: "Roboto",
//       fontSize: "3.8rem",
//       fontWeight: 200,
//     },
//     h2: {
//       fontFamily: "Roboto",
//       fontSize: "2.5rem",
//       fontWeight: 400,
//     },
//     h3: {
//       fontFamily: "Roboto",
//       fontSize: "1.875rem",
//       fontWeight: 500,
//     },
//     h4: {
//       fontFamily: "Roboto",
//       fontSize: "1.5rem",
//       fontWeight: 500,
//     },
//     h5: {
//       fontFamily: "Roboto",
//       fontSize: "1.1rem",
//       fontWeight: 600,
//     },
//     h6: {
//       fontFamily: "Open Sans",
//       fontSize: "1.1rem",
//       fontWeight: 700,
//     },
//     fontFamily: "Open Sans",
//     subtitle1: {
//       fontWeight: 700,
//       fontSize: "0.8rem",
//       lineHeight: 1.55,
//     },
//     button: {
//       fontWeight: 600,
//       fontFamily: "Roboto Nato",
//       lineHeight: 2,
//       strokeWidth: 2,
//       textTransform: "capitalize",
//       borderRadius: 30,
//     },
//     overline: {
//       lineHeight: 2.52,
//       fontSize: "0.7rem",
//       fontWeight: 600,
//     },
//     subtitle2: {
//       fontWeight: 800,
//     },
//     fontSize: 14,
//     body1: {
//       fontSize: "0.9rem",
//     },
//     body2: {
//       fontSize: "0.8rem",
//     },
//   },
// });

// const currentTheme = createTheme({
//   breakpoints: {
//     values: {
//       xs: 0,
//       sm: 600,
//       md: 1000,
//       lg: 1200,
//       xl: 1920,
//     },
//   },
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 30,
//         },
//       },
//       defaultProps: {
//         disableElevation: true,
//       },
//     },
//     // MuiToolbar: {
//     //   styleOverrides: {
//     //     root: {
//     //       height: 50,
//     //     },
//     //   },
//     // },
//     // MuiAppBar: {
//     //   styleOverrides: {
//     //     root: {
//     //       backgroundColor: "#333333",
//     //     },
//     //   },
//     // },
//     MuiButtonBase: {
//       defaultProps: {},
//     },
//     MuiOutlinedInput: {
//       styleOverrides: {
//         notchedOutline: {
//           backgroundColor: "rgba(0, 0, 0, 0.02)",
//         },
//       },
//     },
//   },
//   palette: {
//     primary: {
//       main: "#006faa",
//     },
//     secondary: {
//       main: "#FFC20E",
//     },
//     success: {
//       main: "#64A687",
//     },
//     info: {
//       main: "#006FAA",
//     },
//     warning: {
//       main: "#ff9800",
//     },
//     error: {
//       main: "#c62828",
//     },
//   },
//   shape: {
//     borderRadius: 4,
//   },
//   shadows: [
//     "none",
//     "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)",
//     "0px 1px 2px rgba(100, 116, 139, 0.12)",
//     "0px 1px 4px rgba(100, 116, 139, 0.12)",
//     "0px 1px 5px rgba(100, 116, 139, 0.12)",
//     "0px 1px 6px rgba(100, 116, 139, 0.12)",
//     "0px 2px 6px rgba(100, 116, 139, 0.12)",
//     "0px 3px 6px rgba(100, 116, 139, 0.12)",
//     "0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)",
//     "0px 5px 12px rgba(100, 116, 139, 0.12)",
//     "0px 5px 14px rgba(100, 116, 139, 0.12)",
//     "0px 5px 15px rgba(100, 116, 139, 0.12)",
//     "0px 6px 15px rgba(100, 116, 139, 0.12)",
//     "0px 7px 15px rgba(100, 116, 139, 0.12)",
//     "0px 8px 15px rgba(100, 116, 139, 0.12)",
//     "0px 9px 15px rgba(100, 116, 139, 0.12)",
//     "0px 10px 15px rgba(100, 116, 139, 0.12)",
//     "0px 12px 22px -8px rgba(100, 116, 139, 0.25)",
//     "0px 13px 22px -8px rgba(100, 116, 139, 0.25)",
//     "0px 14px 24px -8px rgba(100, 116, 139, 0.25)",
//     "0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)",
//     "0px 25px 50px rgba(100, 116, 139, 0.25)",
//     "0px 25px 50px rgba(100, 116, 139, 0.25)",
//     "0px 25px 50px rgba(100, 116, 139, 0.25)",
//     "0px 25px 50px rgba(100, 116, 139, 0.25)",
//   ],
//   overrides: {
//     MuiAppBar: {
//       colorInherit: {
//         backgroundColor: "#333333",
//         color: "#fff",
//       },
//     },
//   },
//   props: {
//     MuiAppBar: {
//       color: "inherit",
//     },
//   },
//   typography: {
//     h1: {
//       fontFamily: "Roboto Slab",
//       fontSize: "3.8rem",
//       fontWeight: 200,
//     },
//     h2: {
//       fontFamily: "Roboto Slab",
//       fontSize: "2.5rem",
//       fontWeight: 400,
//     },
//     h3: {
//       fontFamily: "Roboto Slab",
//       fontSize: "1.875rem",
//       fontWeight: 500,
//     },
//     h4: {
//       fontFamily: "Roboto Slab",
//       fontSize: "1.5rem",
//       fontWeight: 500,
//     },
//     h5: {
//       fontFamily: "Roboto Slab",
//       fontSize: "1.1rem",
//       fontWeight: 600,
//     },
//     h6: {
//       fontFamily: "Open Sans",
//       fontSize: "1.1rem",
//       fontWeight: 700,
//     },
//     fontFamily: "Open Sans",
//     subtitle1: {
//       fontWeight: 700,
//       fontSize: "0.8rem",
//       lineHeight: 1.55,
//     },
//     button: {
//       fontWeight: 600,
//       fontFamily: "Roboto Slab",
//       lineHeight: 2,
//       strokeWidth: 2,
//       textTransform: "capitalize",
//       borderRadius: 30,
//     },
//     overline: {
//       lineHeight: 2.52,
//       fontSize: "0.7rem",
//       fontWeight: 600,
//     },
//     subtitle2: {
//       fontWeight: 800,
//     },
//     fontSize: 14,
//     body1: {
//       fontSize: "0.9rem",
//     },
//     body2: {
//       fontSize: "0.8rem",
//     },
//   },
// });
// const darkTheme = createTheme({ palette: { mode: "dark" } });
// const defaultTheme = createTheme({ palette: { mode: "light" } });

// export {
//   ThemeProvider,
//   createTheme,
//   defaultTheme,
//   darkTheme,
//   currentTheme,
//   lightTheme,
// };
